export enum MERCHANT_STATUS {
  WEB = 'web',
  UPLOAD = 'upload',
  ASSESSED = 'assessed',
  APPROVED = 'approved',
  INTEGRATION = 'integration',
  PROCESSING = 'processing'
}

export const MERCHANT_STATUS_VALUES = Object.values(MERCHANT_STATUS);
